// Staging environment
export const environment = {
  production: false,
  staging: true,
  apiBaseUrl: 'https://api.mboum.com',
  apiKey: '104|5CXCEXD3M6U9U7FhWJQUadMpYlKnSd49XSHWPEPK',
  enableLogging: true,
  cacheTTL: 300000, // 5 minutes
  defaultTimezone: 'America/New_York'
};

export let baseUrl: any = 'https://learning-stage.tradersedgenetwork.com/api';
export let chartUrl: any = 'https://learning-stage.tradersedgenetwork.com';
export let backupUrl: any = 'https://learning-stage.tradersedgenetwork.com/8uhYG';
export let uploadsS3BucketBasePath = 'https://hub-uploads-stage.s3.us-east-2.amazonaws.com';
export let mbomBaseUrl = 'test/api/v1';
